import React, { useState } from 'react';
import { observer, useLocalObservable } from 'mobx-react-lite';
import { HelperCore } from '@/common/dependencies';
import appLogger from '@public/log/monitor';

const RefererList = observer((props) => {
  const {
    className = "",
    refer_search,
  } = props;

  if(!refer_search?.length){
    return;
  }

  return (
    <div className={`bg-white rounded-12px p-16px text-12px leading-17px border-1px border-black border-opacity-10 ${className}`}>
      {
        refer_search.slice(0, 10).map((site, index) => {
          return (
            <div
              key={site.title + index}
              className='mb-10px last-of-type:mb-0'
              onClick={() => {
                appLogger.log({
                  key: "aibot_chat",
                  action: 'click',
                  arrt: 'chat_site',
                  ext: site.title,
                  ext1: site.url
                });
              }}
            >
              <a
                target='_blank'
                href={site.url}
                className='!text-black !text-opacity-80 block truncate hover:font-bold !hover:underline'
                dangerouslySetInnerHTML={{ __html : `${index+1}. ${HelperCore.xss(site.title)}` }}
                >
              </a>
            </div>
          )
        })
      }
    </div>
  )
});
export default RefererList;